<template>
  <div>
    <v-container fluid class="pt-0">
      <GptChart :selectedDate="selectedDate" :channelFilter="channelFilter" />
      <v-layout>
        <v-flex xs12>
          <v-data-table
            :loading="isLoading"
            :headers="tableDashboardHeaders"
            :items="tableDashboardRows"
            hide-actions
            :no-data-text="$t('No Data')"
          >
            <template v-slot:items="props">
              <td>
                {{ props.item.question }}
              </td>
              <td>
                {{ props.item.count | numberFormat }}
              </td>
              <td>
                <v-btn fab icon small flat color="grey" @click="handleOpenDetail(props.item)">
                  <v-icon style="display: contents;">search</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
          <v-layout>
            <v-pagination
              class="mt-2 ml-auto"
              v-model="pageDashboardNumber"
              :total-visible="6"
              :length="pageDashboardLength"
              @input="handleChangeDashboardPage"
            ></v-pagination>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Detail Dialog -->
    <v-dialog v-if="conversationSelected" v-model="showMessage" scrollable max-width="800">
      <v-card>
        <v-card-title>
          {{ conversationSelected.question }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <div v-if="isDetailLoading">
            <div style="padding: 30px 0;display: flex; justify-content: center;">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>
          </div>
          <div v-else-if="tableDetailRows.length <= 0">
            <div class="text-xs-center" style="margin: 35px 0 60px;">
              <img src="/static/img/assets/setting/conversation.png" alt style="width: 230px" />
              <p>{{ $t('Not found any chatlog') }}</p>
            </div>
          </div>
          <div v-else>
            <template v-if="tableDetailRows && tableDetailRows.length">
              <v-data-table
                :loading="isDetailLoading"
                :headers="tableDetailHeaders"
                :items="tableDetailRows"
                hide-actions
                :no-data-text="$t('No Data')"
              >
                <template v-slot:items="props">
                  <td>
                    {{ props.item.question }}
                  </td>
                  <td>
                    {{ props.item.count | numberFormat }}
                  </td>
                </template>
              </v-data-table>
              <v-layout>
                <v-pagination
                  class="my-2 ml-auto"
                  v-model="pageDetailNumber"
                  :total-visible="6"
                  :length="pageDetailLength"
                  @input="handleChangeDetailPage"
                ></v-pagination>
              </v-layout>
            </template>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outline color="grey" @click="showMessage = false">{{ $t('cancel') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import gptApi from '@/api/gpt'
import GptChart from './GptChart.vue'
export default {
  props: {
    selectedDate: {
      type: [Object],
      default: () => {}
    },
    channelFilter: {
      type: [String],
      default: 'all'
    }
  },
  data() {
    return {
      isLoading: false,
      tableDashboardHeaders: [
        { text: this.$t('Conversation'), value: 'question', sortable: false },
        { text: this.$t('Count'), value: 'count', sortable: false }
      ],
      tableDashboardRows: [],
      pageDashboardTmp: 1,
      pageDashboardNumber: 1,
      totalDashboard: 0,
      limit: 10,
      offset: 0,
      conversationSelected: null,
      showMessage: false,
      isDetailLoading: false,
      tableDetailHeaders: [
        { text: this.$t('customer says'), value: 'question', sortable: false },
        { text: this.$t('Count'), value: 'count', sortable: false }
      ],
      tableDetailRows: [],
      pageDetailNumber: 1,
      pageDetailTmp: 1,
      totalDetail: 0,
      offsetDetail: 0
    }
  },
  components: { GptChart },
  watch: {
    selectedDate: {
      handler() {
        this.handleGetData()
      },
      deep: true
    },
    channelFilter() {
      this.handleGetData()
    },
    isLoading(value) {
      this.$emit('loading', value)
    },
    showMessage(value) {
      if (!value) {
        this.handleResetDetailState()
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pageDashboardLength() {
      if (this.totalDashboard) {
        let total = parseFloat(this.totalDashboard)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    },
    pageDetailLength() {
      if (this.totalDetail) {
        let total = parseFloat(this.totalDetail)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.handleResetState()
  },
  methods: {
    handleOpenDetail(selected) {
      if (!selected) return
      this.handleResetDetailState()
      this.conversationSelected = selected
      this.handleGetConversationDetail()
      this.showMessage = true
    },
    handleChangeDetailPage(val) {
      if (this.pageDetailTmp !== val) {
        this.pageDetailTmp = val
        this.offsetDetail = this.pageDetailNumber * this.limit - this.limit
        if (this.pageDetailNumber != 1) {
          this.offsetDetail + 1
        }
        this.handleGetConversationDetail()
      }
    },
    handleChangeDashboardPage(val) {
      if (this.pageDashboardTmp !== val) {
        this.pageDashboardTmp = val
        this.offset = this.pageDashboardNumber * this.limit - this.limit
        if (this.pageDashboardNumber != 1) {
          this.offset + 1
        }
        this.handleGetData()
      }
    },
    async handleGetData() {
      try {
        this.isLoading = true
        const response = await gptApi.getChatGPTSummarizeUserQuestion({
          pageId: this.selectedBot.pageid,
          params: {
            limit: this.limit,
            offset: this.offset,
            date_from: this.selectedDate.start,
            date_to: this.selectedDate.end,
            channel: this.channelFilter,
            gpt_reply: 'all'
          }
        })
        const { status, data } = response
        if ([200].includes(status)) {
          this.totalDashboard = data.total
          this.tableDashboardRows = data.data.map(item => {
            return {
              question: item.summarize_question,
              count: item.summarize_question_total
            }
          })
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isLoading = false
      }
    },
    async handleGetConversationDetail() {
      try {
        if (!this.conversationSelected) return
        this.isDetailLoading = true
        const response = await gptApi.getChatGPTSummarizeUserQuestionDetail({
          pageId: this.selectedBot.pageid,
          params: {
            limit: this.limit,
            offset: this.offsetDetail,
            date_from: this.selectedDate.start,
            date_to: this.selectedDate.end,
            channel: this.channelFilter,
            summarize_question: this.conversationSelected.question
          }
        })
        const { status, data } = response
        if ([200].includes(status)) {
          this.totalDetail = data.total
          this.tableDetailRows = data.data.map(item => {
            return {
              question: item.question,
              count: item.question_total
            }
          })
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.isDetailLoading = false
      }
    },
    handleResetState() {
      this.isLoading = true
      this.tableDashboardRows = []
      this.pageDashboardTmp = 1
      this.pageDashboardNumber = 1
      this.totalDashboard = 0
      this.showMessage = false
      this.offset = 0
      this.handleResetDetailState()
      this.handleGetData()
    },
    handleResetDetailState() {
      this.conversationSelected = null
      this.isDetailLoading = true
      this.tableDetailRows = []
      this.pageDetailNumber = 1
      this.pageDetailTmp = 1
      this.totalDetail = 0
      this.offsetDetail = 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/chatgpt/GptDashboard.vue